import React from "react";
import classes from "./CheckBox.module.css";

const CheckBox = ({ id, checked, onChange, value, color, children, disabled, pending, dropClass, ...params }) => {

    const handleChange = (e) => {
        onChange(e.target.checked)
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onChange(!checked);
        }
    };

    return (<label htmlFor={id} className={`${classes.CheckBox} ${dropClass}`}>
        <input
            id={id}
            disabled={disabled}
            type={"checkbox"}
            checked={checked}
            name={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            aria-disabled={disabled} // For screen readers
            {...params}
            style={{ backgroundColor: color, color: color }}
            className={`${classes.CheckBoxInput} ${checked && classes.Checked} ${disabled && classes.Disabled} ${pending && classes.Pending}`} />
        {pending && <div className={classes.Loader}></div>}
        <span className={classes.Text}>{children}</span>
    </label>
    );

};

export default CheckBox;
